import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { textGray } from '../utils/colors';

const StyledLoginForm = styled.form`
  width: 100%;
`;

const LoginInputField = styled.input`
  width: 370px;
  display: block;
  height: 70px;
  border-radius: 10px;
  border: 1px solid;
  border-color: ${textGray};
  padding-left: 1.5625rem;
  font-size: 1.3rem;
  font-style: italic;
  font-weight: 300;
  background: transparent;
  color: ${textGray};
  position: relative;
  outline: none;
  transition: border-color 0.2s ease-in-out;
  margin-bottom: 1.5rem;

  &::placeholder {
    color: #999;
  }

  ${props =>
    props.inverted &&
    css`
      border-color: #ffffff;
    `};

  @media all and (max-width: 776px) {
    width: 100%;
    height: 50px;
  }

  &:focus,
  &:hover {
    border-color: ${props => props.theme.tertiary};
  }
`;

const LoginInputLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 1px;
  color: ${textGray};
  display: block;
  margin-bottom: 0.5rem;
  text-transform: uppercase;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const LoginFormTitle = styled.h2`
  color: ${textGray};
  margin-top: 0;
  margin-bottom: 1.5rem;
  font-size: 1.25rem;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const LoginErrorText = styled.p`
  color: ${textGray};

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const LoginLink = styled(({ noGutterTop, ...props }) => <Link {...props} />)`
  display: inline-block;
  margin: 1.5rem 0;
  color: ${textGray};

  ${props =>
    props.noGutterTop &&
    css`
      margin-top: 0;
    `};
`;

const LoginButtonWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

export {
  LoginErrorText,
  LoginFormTitle,
  LoginInputField,
  LoginInputLabel,
  StyledLoginForm,
  LoginLink,
  LoginButtonWrapper
};



// WEBPACK FOOTER //
// ./src/style-guide/Login.js